// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__fQ08-","label":"Section_label__1cRxW","contentWrap":"Section_contentWrap__24R38","footer":"Section_footer__B0Yi8","footerInner":"Section_footerInner__2laTH"};